import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFlexProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IFlexProps>>
): IComponentSchema<IFlexProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Flex',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Flex,
    'x-component-props': {},
    'x-component-props-config': {},
  };
};
